import type { ModelTrialCaseExample, OnlineModelTrialCase, TaskSettings } from '@/app/types';

// Preserve stable media keys in the API; the existing editor consumes positional references.
export const toModelTrialCaseExample = (item: OnlineModelTrialCase): ModelTrialCaseExample => {
  const content = item.content;
  const groups = [
    ['image', content?.input_images ?? []],
    ['video', content?.input_videos ?? []],
    ['audio', content?.input_audios ?? []],
  ] as const;
  const references = new Map<string, string>();
  for (const [type, media] of groups) {
    media.forEach((entry, index) => {
      references.set(entry.key ?? '', `${type}${index + 1}`);
    });
  }
  const text = (content?.input_text ?? '').replace(/\[@((?:image|video|audio)\d+)\]/g, (match, key: string) =>
    references.has(key) ? `[@${references.get(key)}]` : match,
  );
  return {
    id: item.id ?? '',
    caseKey: item.case_key ?? '',
    text,
    thumbnail: content?.cover_uri || content?.input_images?.[0]?.uri || content?.input_videos?.[0]?.cover_uri,
    images: (content?.input_images ?? []).map(({ uri = '' }) => ({
      sourceImage: uri,
      sourceImagePreview: uri,
      selectedImage: uri,
      selectedImagePreview: uri,
    })),
    videos: (content?.input_videos ?? []).map(({ uri = '', cover_uri, duration }) => ({
      video: uri,
      videoPreview: uri,
      coverImage: cover_uri,
      coverImagePreview: cover_uri,
      duration,
    })),
    audios: (content?.input_audios ?? []).map(({ key, uri = '', duration }) => ({
      src: uri,
      preview: uri,
      name: key,
      duration,
    })),
    settings: content?.settings as Partial<TaskSettings> | undefined,
  };
};
